import { render } from "./ProcessoPartesComponent.vue?vue&type=template&id=20307508&scoped=true"
import script from "./ProcessoPartesComponent.vue?vue&type=script&lang=js"
export * from "./ProcessoPartesComponent.vue?vue&type=script&lang=js"

import "./ProcessoPartesComponent.vue?vue&type=style&index=0&id=20307508&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\Projetos TWM\\eproc\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20307508"]])

export default __exports__